import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
    Box,
    Container,
    Paper,
    Typography,
    RadioGroup,
    FormControlLabel,
    Radio,
    Button,
    Card,
    CardContent,
    LinearProgress,
    Alert,
    Grid,
    Divider,
    useMediaQuery,
    useTheme,
    Stepper,
    Step,
    StepLabel
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { CheckCircle, RadioButtonUnchecked } from '@mui/icons-material';
import { AppBar, Toolbar } from '@mui/material';
import adayTestService from '../../service/TestMerkeziServices/AdayTestService';
import adayTestYanitlarService from '../../service/TestMerkeziServices/AdayTestYanitlarService';
import TestDurumEnum from '../../enum/TestMerkezi/TestDurumEnum';
import useGlobal from '../../util/Global';
import Accountservice from '../../service/Core/AccountService';

// Test sayfası için özel AdayPage - menüsüz
const TestAdayPage = ({ children }) => {
    const PRIVACY_LINKS = [
        {
            label: 'Kişisel Verilerin Korunması',
            href: 'https://www.securitas.com.tr/settings-page/kisisel-verilerin-korunmasi/',
            title: 'Kişisel Verilerin Korunması',
        },
        {
            label: 'Çerez Politikası',
            href: 'https://www.securitas.com.tr/settings-page/kisisel-verilerin-korunmasi/cerez-politikasi/',
            title: 'Çerez Politikası',
        },
        {
            label: 'Gizlilik Politikası',
            href: 'https://www.securitas.com.tr/settings-page/kisisel-verilerin-korunmasi/gizlilik-politikasi/',
            title: 'Gizlilik Politikası',
        },
    ];

    const AdayPageFooter = () => (
        <Box
            component="footer"
            borderTop="1px solid #CDC9C8"
            sx={{
                bgcolor: 'grey.50',
                color: '#53565A',
                fontFamily: "Open Sans, sans-serif",
                p: 2,
                maxHeight: '10vh'
            }}
        >
            <Grid container>
                <Grid item xs={12} md={6}>
                    <Typography variant="body2" sx={{ fontSize: 12 }}>
                        Securitas Türkiye İnsan Kaynakları
                    </Typography>
                </Grid>
                <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                    }}
                >
                    <Typography variant="body2" sx={{ fontSize: 12 }}>
                        {PRIVACY_LINKS.map((link, idx) => (
                            <React.Fragment key={link.href}>
                                <a
                                    href={link.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title={link.title}
                                    style={{ color: '#798D9E', textDecoration: 'none' }}
                                >
                                    {link.label}
                                </a>
                                {idx < PRIVACY_LINKS.length - 1 && ' | '}
                            </React.Fragment>
                        ))}
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    );

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <AppBar className="ilanapp" position="static">
                <Toolbar sx={{ display: "flex", justifyContent: "flex-start" }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <img
                            src="/sc-ua-logo-white-2.svg"
                            alt="Securitas"
                            style={{ height: "auto", maxHeight: '10vh', minWidth: '45vw', width: '30vw', maxWidth: '60vw' }}
                        />
                    </Box>
                </Toolbar>
            </AppBar>

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    bgcolor: 'background.default',
                    p: 0,
                }}
            >
                {children}
            </Box>

            <AdayPageFooter />
        </Box>
    );
};



const TestHeader = styled(Box)(({ theme }) => ({
    background: 'linear-gradient(135deg, #6143D8 0%, #5C3B90 100%)',
    color: 'white',
    padding: theme.spacing(1.5, 2),
    textAlign: 'center',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="white" fill-opacity="0.08"%3E%3Cpath d="M30 30c0 16.569-13.431 30-30 30v30h60V30H30z"/%3E%3C/g%3E%3C/svg%3E")',
    }
}));

const QuestionCard = styled(Card)(({ theme, answered }) => ({
    marginBottom: theme.spacing(3),
    transition: 'all 0.3s ease',
    borderRadius: 16,
    border: answered ? '2px solid #6143D8' : '1px solid #e0e0e0',
    backgroundColor: answered ? 'rgba(97, 67, 216, 0.02)' : 'white',
    boxShadow: answered 
        ? '0 8px 25px rgba(97, 67, 216, 0.15)' 
        : '0 4px 20px rgba(0, 0, 0, 0.08)',
    position: 'relative',
    '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 12px 30px rgba(97, 67, 216, 0.2)',
    },
    '&::before': answered ? {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '4px',
        background: 'linear-gradient(90deg, #6143D8, #5C3B90)',
        borderRadius: '16px 16px 0 0'
    } : {}
}));

const ProgressCard = styled(Card)(({ theme }) => ({
    background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
    borderRadius: 16,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    position: 'sticky',
    top: 20,
    zIndex: 100,
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
}));

const OptionButton = styled(FormControlLabel)(({ theme, selected }) => ({
    margin: 0,
    marginBottom: theme.spacing(1.5),
    width: '100%',
    '& .MuiFormControlLabel-label': {
        width: '100%',
        padding: theme.spacing(2),
        borderRadius: 12,
        border: selected ? '2px solid #6143D8' : '1px solid #e0e0e0',
        backgroundColor: selected ? 'rgba(97, 67, 216, 0.08)' : 'white',
        transition: 'all 0.2s ease',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: selected ? 'rgba(97, 67, 216, 0.12)' : 'rgba(97, 67, 216, 0.04)',
            borderColor: '#6143D8',
            transform: 'translateX(8px)'
        }
    },
    '& .MuiRadio-root': {
        display: 'none'
    }
}));

const SubmitButton = styled(Button)(({ theme }) => ({
    background: 'linear-gradient(135deg, #6143D8 0%, #5C3B90 100%)',
    color: 'white',
    padding: theme.spacing(2, 6),
    borderRadius: 25,
    fontSize: '1.1rem',
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: '0 8px 25px rgba(97, 67, 216, 0.3)',
    transition: 'all 0.3s ease',
    '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 12px 35px rgba(97, 67, 216, 0.4)',
        background: 'linear-gradient(135deg, #5C3B90 0%, #6143D8 100%)',
    },
    '&:disabled': {
        background: '#cccccc',
        color: '#666666',
        transform: 'none',
        boxShadow: 'none'
    }
}));

const QuestionNumber = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: 10,
    left: 20,
    background: 'linear-gradient(135deg, #6143D8 0%, #5C3B90 100%)',
    color: 'white',
    padding: theme.spacing(0.8, 2),
    borderRadius: 20,
    fontSize: '0.85rem',
    fontWeight: 600,
    boxShadow: '0 4px 15px rgba(97, 67, 216, 0.3)',
    zIndex: 10,
    display: 'flex',
    alignItems: 'center',
    minHeight: 32,
}));

const TestMerkeziPage = () => {
    const { g } = useGlobal();
    const location = useLocation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    
    // State management
    const [loading, setLoading] = useState(true);
    const [testData, setTestData] = useState(null);
    const [error, setError] = useState(null);
    const [answers, setAnswers] = useState({});
    const [saving, setSaving] = useState(false);
    const [testCompleted, setTestCompleted] = useState(false);
    const [authToken, setAuthToken] = useState(null);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

    // URL parametrelerini al
    const getUrlParams = () => {
        const params = new URLSearchParams(location.search);
        return {
            tenantKey: params.get('t'),
            guid: params.get('guid')
        };
    };

    // Aday girişi yapıp token al
    const fetchAdayToken = async (tenantKey) => {
        if (!tenantKey) {
            setError("Giriş için gerekli bilgi (tenantKey) bulunamadı.");
            return;
        }
        try {
            const res = await Accountservice.loginAsAday({ tenant: tenantKey });
            if (res && res.token) {
                setAuthToken(res.token);
                return res.token;
            } else {
                setError("Oturum açılamadı. Lütfen bilgileri kontrol edin.");
                return null;
            }
        } catch (error) {
            console.error("Login failed:", error);
            setError("Giriş sırasında bir hata oluştu.");
            return null;
        }
    };

    // Test verilerini getir
    const fetchTestData = async (token) => {
        try {
            setLoading(true);
            const { guid } = getUrlParams();
            
            if (!guid) {
                setError('Test GUID parametresi bulunamadı');
                return;
            }

            if (!token) {
                setError('Yetkilendirme anahtarı bulunamadı.');
                return;
            }

            const response = await adayTestService.getQuestions(guid, token);
            
            if (response && response.isSuccess && response.resultObject) {
                const testData = response.resultObject;
                
                // Test ilk kez açıldığında ve henüz yanıtlanmamışsa gerçek başlama zamanını güncelle
                if (testData.durum !== TestDurumEnum.Yanitlandi) {
                    const updateData = {
                        Id: testData.id,
                        BaslamaZamani: new Date().toISOString()
                    };
                    // Token ile birlikte yeni updateTest metodunu çağırıyoruz
                    const updateResult = await adayTestService.updateTest(updateData, token);
                    if (updateResult && updateResult.isSuccess) {
                        testData.baslamaZamani = updateData.BaslamaZamani;
                    } else {
                        console.error("Test başlangıç zamanı güncellenemedi.");
                        setError("Test bilgileri güncellenirken bir sorun oluştu.");
                    }
                }
                
                setTestData(testData);
                
                // Mevcut cevapları başlat
                const initialAnswers = {};
                testData.sorular?.forEach(soru => {
                    if (soru.secilenCevap) {
                        initialAnswers[soru.id] = soru.secilenCevap;
                    }
                });
                setAnswers(initialAnswers);
            } else {
                setError('Test verileri getirilemedi');
            }
        } catch (err) {
            console.error('Test yüklenirken hata:', err);
            setError('Test yüklenirken bir hata oluştu');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const { tenantKey } = getUrlParams();
        fetchAdayToken(tenantKey).then(token => {
            if (token) {
                fetchTestData(token);
            }
        });
    }, []);

    // Cevap seçimi
    const handleAnswerChange = (questionId, answerId) => {
        setAnswers(prev => ({
            ...prev,
            [questionId]: parseInt(answerId)
        }));
    };

    // Test kaydetme
    const handleSaveTest = async () => {
        try {
            setSaving(true);
            setError(null);
            
            // Tüm sorular cevaplanmış mı kontrol et (Zorunlu)
            const unansweredQuestions = testData.sorular.filter(soru => 
                !answers[soru.id]
            );
            
            if (unansweredQuestions.length > 0) {
                setError(`Lütfen tüm soruları cevaplayınız. ${unansweredQuestions.length} soru eksik.`);
                // Scroll to first unanswered question
                setTimeout(() => {
                    const firstUnanswered = document.querySelector(`[data-question-id="${unansweredQuestions[0].id}"]`);
                    if (firstUnanswered) {
                        firstUnanswered.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }, 100);
                return;
            }

            // Cevapları hazırla
            const answerData = [];
            testData.sorular.forEach(soru => {
                if (answers[soru.id]) {
                    answerData.push({
                        AdayId: testData.adayId,
                        IKTestMerkeziSorularId: soru.id,
                        IKTestMerkeziSoruYanitlarId: answers[soru.id],
                        IKTestMerkeziAdayTestId: testData.id
                    });
                }
            });

            // Cevapları kaydet
            const saveResult = await adayTestYanitlarService.saveAnswers(answerData, authToken);
            
            if (saveResult && saveResult.isSuccess) {
                // Test durumunu "Yanıtlandı" olarak güncelle
                const completeResult = await adayTestService.completeTest(testData.id, authToken);
                
                if (completeResult && completeResult.isSuccess) {
                    // Test sonuçlarını hesapla
                    const hesaplaResult = await adayTestService.hesaplaTestSonuclari(testData.id, authToken);
                    
                    if (hesaplaResult && hesaplaResult.isSuccess) {
                        setTestCompleted(true);
                    } else {
                        setError('Test tamamlandı ancak sonuçlar hesaplanamadı.');
                    }
                } else {
                    setError('Cevaplar kaydedildi ancak test durumu güncellenemedi.');
                }
            } else {
                setError(saveResult?.message || 'Cevaplar kaydedilemedi. Lütfen tekrar deneyiniz.');
            }
            
        } catch (err) {
            console.error('Test kaydedilirken hata:', err);
            setError('Test kaydedilirken bir hata oluştu. Lütfen tekrar deneyiniz.');
        } finally {
            setSaving(false);
        }
    };

    // Test durumu kontrolü
    const getTestStatus = () => {
        if (!testData) return null;

        const now = new Date();
        const startTime = testData.baslamaZamani ? new Date(testData.baslamaZamani) : null;
        const endTime = testData.bitisZamani ? new Date(testData.bitisZamani) : null;

        if (testData.durum === TestDurumEnum.Yanitlandi) {
            return { status: 'completed', message: g("message.testDahaOnceTamamlanmis") };
        }

        if (endTime && now > endTime) {
            return { status: 'expired', message: g("message.testSuresiDolmus") };
        }

        if (startTime && now < startTime) {
            return { status: 'notStarted', message: g("message.testHenuzBaslamamis") };
        }

        if (!testData.sorular || testData.sorular.length === 0) {
            return { status: 'noQuestions', message: g("message.testIcinSoruBulunmuyor") };
        }

        return { status: 'active', message: g("label.testAktif") };
    };

    // Loading durumu
    if (loading) {
        return (
            <TestAdayPage>
                <Container maxWidth="md" sx={{ py: 6 }}>
                    <Card sx={{ p: 4, textAlign: 'center', borderRadius: 4 }}>
                        <Typography variant="h5" gutterBottom color="primary" fontWeight={600}>
                            {g("label.testYukleniyor")}
                        </Typography>
                        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                            {g("message.testSorulariHazirlaniyor")}
                        </Typography>
                        <LinearProgress 
                            sx={{ 
                                width: '100%', 
                                height: 8, 
                                borderRadius: 4,
                                backgroundColor: 'rgba(97, 67, 216, 0.1)',
                                '& .MuiLinearProgress-bar': {
                                    background: 'linear-gradient(90deg, #6143D8, #5C3B90)'
                                }
                            }} 
                        />
                    </Card>
                </Container>
            </TestAdayPage>
        );
    }

    // Hata durumu
    if (error) {
        return (
            <TestAdayPage>
                <Container maxWidth="md" sx={{ py: 6 }}>
                    <Alert 
                        severity="error" 
                        sx={{ 
                            borderRadius: 4, 
                            p: 3,
                            boxShadow: '0 8px 25px rgba(244, 67, 54, 0.15)' 
                        }}
                    >
                        <Typography variant="h6" fontWeight={600}>{g("label.testHatasi")}</Typography>
                        <Typography sx={{ mt: 1 }}>{error}</Typography>
                    </Alert>
                </Container>
            </TestAdayPage>
        );
    }

    // Test tamamlandı
    if (testCompleted) {
        return (
            <TestAdayPage>
                <Container maxWidth="md" sx={{ py: 6 }}>
                    <Card sx={{ p: 4, textAlign: 'center', borderRadius: 4 }}>
                        <CheckCircle sx={{ fontSize: 64, color: '#4caf50', mb: 2 }} />
                        <Typography variant="h4" fontWeight={600} color="primary" gutterBottom>
                            {g("label.testTamamlandi")}
                        </Typography>
                        <Typography variant="h6" color="text.secondary" sx={{ mb: 2 }}>
                            {g("message.testiBasariylaTamamladiniz")}
                        </Typography>
                        <Typography variant="body1" color="text.secondary">
                            {g("message.testSonuclariDegerlendirilecek")}
                        </Typography>
                    </Card>
                </Container>
            </TestAdayPage>
        );
    }

    const testStatus = getTestStatus();

    // Test aktif değilse uyarı göster
    if (testStatus && testStatus.status !== 'active') {
        return (
            <TestAdayPage>
                <Container maxWidth="md" sx={{ py: 6 }}>
                    <Alert 
                        severity="warning" 
                        sx={{ 
                            borderRadius: 4, 
                            p: 3,
                            boxShadow: '0 8px 25px rgba(255, 193, 7, 0.15)' 
                        }}
                    >
                        <Typography variant="h6" fontWeight={600}>{g("label.testDurumu")}</Typography>
                        <Typography sx={{ mt: 1 }}>{testStatus.message}</Typography>
                    </Alert>
                </Container>
            </TestAdayPage>
        );
    }

    // Progress hesaplaması
    const totalQuestions = testData?.sorular?.length || 0;
    const answeredQuestions = Object.keys(answers).length;
    const progressPercentage = totalQuestions > 0 ? (answeredQuestions / totalQuestions) * 100 : 0;

    return (
        <TestAdayPage>
            {/* Test Header */}
            <TestHeader>
                <Container maxWidth="lg">
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={8}>
                            <Box sx={{ textAlign: 'left' }}>
                                <Typography variant="h6" fontWeight={600} gutterBottom>
                                    {testData?.testTipAdi || g("label.testMerkezi")}
                                </Typography>
                                {testData?.testTipAciklama && (
                                    <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                        {testData.testTipAciklama}
                                    </Typography>
                                )}
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Box sx={{ textAlign: { xs: 'left', md: 'right' } }}>
                                {testData?.adayAdSoyad && (
                                    <Typography variant="body1" fontWeight={500}>
                                        {g("label.aday")}: {testData.adayAdSoyad}
                                    </Typography>
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </TestHeader>

            <Container maxWidth="lg" sx={{ pb: 4, px: { xs: 2, sm: 3 }, mt: 3 }}>
                {/* Progress Card */}
                <ProgressCard>
                    <Grid container alignItems="center" spacing={2}>
                        <Grid item xs>
                            <Typography variant="h6" fontWeight={600} color="primary">
                                {g("label.testIlerlemesi")}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="h4" fontWeight={700} color="primary" sx={{ textAlign: 'right' }}>
                                {answeredQuestions} <Typography component="span" variant="h6" color="text.secondary">/ {totalQuestions}</Typography>
                            </Typography>
                        </Grid>
                    </Grid>
                    
                    <Box sx={{ mt: 2 }}>
                        <LinearProgress
                            variant="determinate"
                            value={progressPercentage}
                            sx={{
                                height: 12,
                                borderRadius: 6,
                                backgroundColor: 'rgba(97, 67, 216, 0.1)',
                                '& .MuiLinearProgress-bar': {
                                    background: 'linear-gradient(90deg, #6143D8, #5C3B90)',
                                    borderRadius: 6
                                }
                            }}
                        />
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                            {answeredQuestions} / {totalQuestions} {g("label.soruCevaplandi")} (%{Math.round(progressPercentage)})
                        </Typography>
                    </Box>
                </ProgressCard>

                {/* Error Alert */}
                {error && (
                    <Alert 
                        severity="error" 
                        sx={{ 
                            mb: 3, 
                            borderRadius: 4,
                            boxShadow: '0 4px 20px rgba(244, 67, 54, 0.15)' 
                        }}
                    >
                        {error}
                    </Alert>
                )}

                {/* Questions */}
                <Grid container spacing={3}>
                    {testData?.sorular?.map((soru, index) => {
                        const isAnswered = !!answers[soru.id];
                        const selectedAnswer = answers[soru.id];
                        
                        return (
                            <Grid item xs={12} key={soru.id}>
                                <QuestionCard answered={isAnswered} data-question-id={soru.id}>
                                    <QuestionNumber>
                                        {isAnswered ? <CheckCircle sx={{ fontSize: 20, mr: 1 }} /> : null}
                                        {g("label.soru")} {index + 1}
                                    </QuestionNumber>
                                    
                                    <CardContent sx={{ pt: 7, pb: 3 }}>
                                        <Typography 
                                            variant={isMobile ? "h6" : "h5"} 
                                            fontWeight={600} 
                                            color="text.primary"
                                            sx={{ mb: 3, lineHeight: 1.4 }}
                                        >
                                            {soru.soru}
                                        </Typography>
                                        
                                        <RadioGroup
                                            value={selectedAnswer || ''}
                                            onChange={(e) => handleAnswerChange(soru.id, e.target.value)}
                                        >
                                            {soru.soruYanitlar?.map((yanitlar, optionIndex) => {
                                                const isSelected = selectedAnswer == yanitlar.id;
                                                return (
                                                    <OptionButton
                                                        key={yanitlar.id}
                                                        value={yanitlar.id}
                                                        selected={isSelected}
                                                        control={<Radio />}
                                                        label={
                                                            <Box display="flex" alignItems="center">
                                                                <Box
                                                                    sx={{
                                                                        width: 24,
                                                                        height: 24,
                                                                        borderRadius: '50%',
                                                                        border: isSelected ? '2px solid #6143D8' : '2px solid #e0e0e0',
                                                                        backgroundColor: isSelected ? '#6143D8' : 'transparent',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        mr: 2,
                                                                        transition: 'all 0.2s ease'
                                                                    }}
                                                                >
                                                                    {isSelected && (
                                                                        <CheckCircle sx={{ fontSize: 16, color: 'white' }} />
                                                                    )}
                                                                </Box>
                                                                <Box flex={1}>
                                                                    <Typography 
                                                                        variant="body1" 
                                                                        fontWeight={isSelected ? 600 : 400}
                                                                        color={isSelected ? 'primary' : 'text.primary'}
                                                                    >
                                                                        {yanitlar.cevap}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                        }
                                                    />
                                                );
                                            })}
                                        </RadioGroup>
                                    </CardContent>
                                </QuestionCard>
                            </Grid>
                        );
                    })}
                </Grid>

                {/* Submit Button */}
                <Box display="flex" justifyContent="center" mt={5} mb={3}>
                    <SubmitButton
                        size="large"
                        onClick={handleSaveTest}
                        disabled={saving || answeredQuestions < totalQuestions}
                        startIcon={saving ? <LinearProgress size={20} /> : <CheckCircle />}
                    >
                        {saving ? g("label.testKaydediliyor") : 
                         answeredQuestions < totalQuestions ? 
                         `${totalQuestions - answeredQuestions} ${g("label.soruKaldi")}` : 
                         g("button.testiTamamla")}
                    </SubmitButton>
                </Box>

                {/* Completion Notice */}
                {answeredQuestions < totalQuestions && (
                    <Alert 
                        severity="info" 
                        sx={{ 
                            borderRadius: 4,
                            backgroundColor: 'rgba(97, 67, 216, 0.05)',
                            border: '1px solid rgba(97, 67, 216, 0.2)',
                            '& .MuiAlert-icon': { color: '#6143D8' }
                        }}
                    >
                        <Typography fontWeight={600}>
                            {g("message.lutfenTumSorulariCevaplayiniz")}
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 0.5 }}>
                            {g("message.testTamamlanmasiIcinKalanSoru").replace("{count}", totalQuestions - answeredQuestions)}
                        </Typography>
                    </Alert>
                )}
            </Container>
        </TestAdayPage> 
    );
};

export default TestMerkeziPage; 